import React from 'react';

export const BaseViewportPlugin = React.forwardRef<
    HTMLDivElement,
    {
        name?: string;
        enablePointerEvents?: boolean;
        styles?: React.CSSProperties;
        children: React.ReactNode;
    }
>(({ name, enablePointerEvents, children, styles }, ref) => {
    return (
        <div
            ref={ref}
            className="editor-plugin"
            data-plugin={name}
            style={{
                pointerEvents: enablePointerEvents ? 'initial' : 'none',
                ...styles,
            }}
        >
            {children}
        </div>
    );
});

BaseViewportPlugin.displayName = 'BaseViewportPlugin';
